import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getStatus } from 'actions';
import { getTranslations } from 'actions/languages';
import { getActiveLanguage, onLanguageChange, setActiveLanguage } from '@haldor/ui';
var Localization = /*#__PURE__*/function (_Component) {
  function Localization() {
    var _this;
    _classCallCheck(this, Localization);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Localization, [].concat(args));
    _defineProperty(_this, "UNSAFE_componentWillMount", function () {
      var localLang = localStorage.getItem('language');
      if (localLang != null) {
        setActiveLanguage(localLang);
      }
      if (_this.props.translations == null) {
        _this.props.getTranslations(getActiveLanguage());
      }
      onLanguageChange(function (lcid) {
        localStorage.setItem('language', lcid);
        _this.props.getTranslations(lcid);
        _this.props.getStatus(lcid);
      });
    });
    return _this;
  }
  _inherits(Localization, _Component);
  return _createClass(Localization, [{
    key: "render",
    value: function render() {
      if (this.props.translations == null) {
        return /*#__PURE__*/React.createElement("div", null);
      }
      return this.props.children;
    }
  }]);
}(Component);
function mapStateToProps(state) {
  return {
    translations: state.Languages.translations
  };
}
export default connect(mapStateToProps, {
  getTranslations: getTranslations,
  getStatus: getStatus
})(Localization);